module.exports = __webpack_public_path__ + "img/Acmi_13.f942dec5.gif";